import React from "react";
// import { cn } from "@/shared/ui/utils"

function Skeleton({ className, ...props }) {
  return (
    <div
      className={`rounded-md bg-muted tbk-animate-pulse ${className}`}
      {...props}
    />
  );
}

export { Skeleton };
